import React, { useEffect, useState, useRef } from "react";
import LifeCycle from "./charts/LifeCycle";
import Annualize from "./charts/annualize";
import Total from "./charts/total";
import { Card, CardHeader, CardBody } from "../../../components/card/card";

function MachineList() {
  return (
    <div>
      <h2 className="page-header">Lifecycle</h2>
      <Card className={"bg-blue-900 bg-opacity-80 border-blue card mb-3"}>
        <CardHeader>
          <div style={{ width: "150px" }}>
            <select
              className={"form-control border-theme text-theme text-center"}
            >
              <option value="">- Filter Strategy -</option>
              <option value="default">Default Strategy</option>
              <option value="Strategy 1">Strategy 1 (⭐️ Recomended)</option>
              <option value="Strategy 2">Strategy 2 (️ ✅Implemented)</option>
              <option value="Strategy 3">Strategy 3</option>
            </select>
          </div>
        </CardHeader>
        <CardBody>
          <div>
            Asset ID: <b>ASD-GSE-01CR01-PAC002</b>
          </div>
          <div>
            Asset Name: <b>AIR COMPRESSOR</b>
          </div>

          {/*<LifeCycle />*/}
          <hr />
          <h3>Simulated Annualized LCC</h3>
          <small>
            <sup>*</sup>Simulation start from 2025
          </small>
          <Annualize />
          <hr />
          <h3>Accumulated LCC</h3>
          <Total />
        </CardBody>
      </Card>
    </div>
  );
}

export default MachineList;
